import { faCalendarDays, faWarehouse } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from 'antd';

import {
  PF,
  STATUS_ICONS,
  STATUS_LABELS,
} from '@app/pages/Warehouses/Inventory/components/InventoryCard/constants';
import type { HeaderType } from '@app/pages/Warehouses/Inventory/components/InventoryCard/types';

const { Text } = Typography;

export const Header: HeaderType = ({
  date,
  warehouseName,
  comment,
  status,
  progress,
}) => (
  <div className={`${PF}_header`}>
    <div className={`${PF}_header_row`}>
      {!!date && (
        <Text>
          <FontAwesomeIcon
            icon={faCalendarDays}
            className={`${PF}_header_icon`}
          />
          {date}
        </Text>
      )}

      {!!warehouseName && (
        <Text className={`${PF}_header_warehouse`}>
          <FontAwesomeIcon icon={faWarehouse} className={`${PF}_header_icon`} />
          {warehouseName}
        </Text>
      )}
      {!!status && (
        <Text className={`${PF}_header_status`}>
          <FontAwesomeIcon
            icon={STATUS_ICONS[status]}
            className={`${PF}_header_icon`}
          />
          {STATUS_LABELS[status]}{' '}
          {progress !== undefined && <span>{progress}%</span>}
        </Text>
      )}
    </div>
    {!!comment && <Text className={`${PF}_header_comment`}>{comment}</Text>}
  </div>
);
